import {onFind} from "@elements/init-modules-in-scope";
import {on, hasClass, addClass, removeClass, find, findIn, findAllIn, closest, removeAttribute, setAttribute} from "@elements/dom-utils";
import TerracePlanner from "../index";
import {visualizeCompleteness, updateTab, setTabData, unCompleteTab, completeTab} from "../tabManager";

export function init() {
    if(TerracePlanner.tabConfig.surface.complete) {
        visualizeCompleteness('surface');
        updateSurfaceTabText();
    }

    findAllIn('.js-planner__form-input-row', TerracePlanner.element).map((inputRow) => {
       if (findIn('input:checked', inputRow)) {
           findAllIn('.js-planner__form-input', inputRow).map((input) => removeClass('is-not-selected', input));
       } else {
           findAllIn('.js-planner__form-input', inputRow).map((input) => addClass('is-not-selected', input));
       }
    });

    findAllIn('.js-planner__form-select-type', TerracePlanner.element).map((item) => {
        on('click', (evt) => {
            completeListener(evt, item)
        }, item)
    });

    if (findIn('.js-planner__form-stock-only', TerracePlanner.element)) {
        on('click', (evt) => {
            updateSurface();

            unCompleteTab('subStructure');
            unCompleteTab('product');
            unCompleteTab('plankPattern');
            unCompleteTab('summary');
        }, findIn('.js-planner__form-stock-only', TerracePlanner.element))
    }
}

export function updateSurfaceTabText() {
    let text = [];

    findAllIn('#surfaceForm input[type=radio]:checked', TerracePlanner.element).map((item) => {
        text.push(item.getAttribute('data-tab-label'));
    });

    updateTab('surface', text.join(', '));
}

/**
 * @see TerracePlanner.outlineAreaCalculation | why?
 */
export function updateSurface() {
    updateSurfaceTabText();

    // setTabData('surface', find('#surfaceForm').serialize());
    setTabData('surface', new FormData(find('#surfaceForm')));

}

/**
 * completes the tab and switches to the next
 */
export function completeSurface() {
    console.log('complete surface ???')
    unCompleteTab('subStructure');
    completeTab('surface', 'subStructure');

    unCompleteTab('product');
    unCompleteTab('plankPattern');
    unCompleteTab('summary');
}

/**
 * updates and completes the tab and switches to the next
 */
export function complete() {
    updateSurface();
    completeSurface();
}

/**
 * listener to check a clicked radio (most likely called before the change event) and complete the tab
 * this way it works for both checked and unchecked radios
 *
 * @param event
 */
export function completeListener(evt, input) {
    input.checked = true;

    findAllIn('.js-planner__form-input', closest('.js-planner__form-input-row', input)).map((input) => removeClass('is-not-selected', input));

    complete();
}